import {ReactElement} from "react";
import {Link} from "@mui/material";
import {Colors} from "@bounce/shared/ui";


const protocol = "((?:http|https|rtsp):\\/\\/)";
const domainAndSubdomains = "(?:(?:[a-zA-Z0-9][-]*)*[a-zA-Z0-9]\\.)+";
const genericTopLevelDomains =
  "aero|arpa|asia|app|" +
  "biz|buzz|" +
  "cat|com|coop|credit|" +
  "edu|" +
  "gov|" +
  "info|int|" +
  "jobs|" +
  "mil|mobi|museum|" +
  "name|net|" +
  "org|" +
  "pro|" +
  "tel|travel";
const countryTopLevelDomains =
  "a[cdefgilmnoqrstuwxz]|" +
  "b[abdefghijlmnoqrstvwyz]|" +
  "c[acdfghiklmnoruvwxyz]|" +
  "d[ejkmoz]|" +
  "e[ceghrstu]|" +
  "f[ijkmor]|" +
  "g[abdefghilmnpqrstuwy]|" +
  "h[kmnrtu]|" +
  "i[delmnoqrst]|" +
  "j[emop]|" +
  "k[eghimnprwyz]|" +
  "l[abcikrstuvy]|" +
  "m[acdefghklmnopqrstuvwxyz]|" +
  "n[acefgilopruz]|" +
  "om|" +
  "p[aefghklmnrstwy]|" +
  "qa|" +
  "r[eosuw]|" +
  "s[abcdeghijklmnorstuvxyz]|" +
  "t[cdfghjklmnoprtvwz]|" +
  "u[agkmsyz]|" +
  "v[aceginu]|" +
  "w[fs]|" +
  "y[etu]|" +
  "z[amw]";
const port = "(?:\\:\\d{1,5})?";
const path = '(?:[/?#][^\\s"]*)?';
const startOfMatchedUrl = "(?:\\b|^)";
const endOfMatchedUrl = "(?:\\b|$)";

// only captured group is the protocol, e.g. https://
const urlRegexString = `${startOfMatchedUrl}(?:${protocol}\\S+|(?:${protocol})?${domainAndSubdomains}(?:${genericTopLevelDomains}|${countryTopLevelDomains})${port}${path})${endOfMatchedUrl}`;
const urlRegex = new RegExp(urlRegexString, "gi");

const isPartOfEmail = (line: string, matchIndex: number): boolean => {
  // Check if the URL match is part of an email address
  const beforeMatch = line.substring(0, matchIndex);
  // If there's an @ symbol before the match with no space between, it's part of an email
  const lastAtIndex = beforeMatch.lastIndexOf("@");
  const lastSpaceIndex = Math.max(beforeMatch.lastIndexOf(" "), beforeMatch.lastIndexOf("\t"));
  return lastAtIndex > lastSpaceIndex;
};

export const parseMessageBody = (body: string, belongToCurrentUser: boolean) => {
  const renderedResult: Array<ReactElement | string> = [];

  const lineBreakRegexp = new RegExp(/[\n\r]/);
  const lines = body.split(lineBreakRegexp);
  lines.forEach((line) => {
    let index = 0;
    let regexResult;

    while ((regexResult = urlRegex.exec(line))) {
      const [url, urlProtocol] = regexResult;

      // Skip if this URL is part of an email address
      if (isPartOfEmail(line, regexResult.index)) {
        continue;
      }

      // add all regular body text that comes before the url
      renderedResult.push(line.substring(index, regexResult.index));

      const urlHref = urlProtocol ? url : `http://${url}`;
      renderedResult.push(
        <Link
          href={urlHref}
          key={index}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: Colors.primary._800,
            textDecorationColor: belongToCurrentUser ? Colors.bw.white : Colors.primary._800,
          }}
        >
          {url}
        </Link>
      );
      index = regexResult.index + regexResult[0].length;
    }

    // add all regular body text that comes after the url
    if (index < line.length) {
      renderedResult.push(line.substring(index, line.length));
    }

    renderedResult.push("\n");
  });

  // remove the newline added after the last parsed line
  renderedResult.pop();

  return renderedResult;
};
